import type {NavigationGuard} from 'vue-router';
import useAccount from '@/composables/useAccount/useAccount';
import logToMonitor from '@/utils/logging';

export const fulfilmentGuard: NavigationGuard = (to, from) => {
  const {accountSettings} = useAccount();

  if (!Boolean(accountSettings.value.fulfilment)) {
    logToMonitor(new Error('Fulfilment not enabled'), {
      _myparcel_extra_info: 'Fulfilment route guard blocked navigation because fulfilment flag disabled',
      _myparcel_to_route: to.name,
      _myparcel_from_route: from.name,
    });

    return {
      name: 'dashboard',
    };
  }

  return true;
};

export const createFulfilmentGuard = (requiresFulfilmentCallback: () => boolean): NavigationGuard => {
  return (to, from) => {
    if (requiresFulfilmentCallback()) {
      return fulfilmentGuard(to, from);
    }

    return true;
  };
};
